"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewarderWrapper = void 0;
const tslib_1 = require("tslib");
const web3_js_1 = require("@solana/web3.js");
const pda_1 = require("./pda");
const quarry_1 = require("./quarry");
class RewarderWrapper {
    constructor(mineWrapper, rewarderKey, rewarderData) {
        this.mineWrapper = mineWrapper;
        this.rewarderKey = rewarderKey;
        this.rewarderData = rewarderData;
        this.sdk = mineWrapper.sdk;
        this.program = mineWrapper.program;
    }
    /**
     * Gets the quarry associated with the given token.
     * @param token
     * @returns
     */
    getQuarry(token) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const quarryKey = yield this.getQuarryKey(token);
            return yield quarry_1.QuarryWrapper.load({
                sdk: this.sdk,
                token,
                key: quarryKey,
            });
        });
    }
    /**
     * Gets the public key of a quarry for a token.
     * @param token
     * @returns
     */
    getQuarryKey(token) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            return yield this.getQuarryKeyForMint(token.mintAccount);
        });
    }
    /**
     * Gets the public key of a quarry for a token mint.
     * @param token
     * @returns
     */
    getQuarryKeyForMint(mint) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const [quarryKey] = yield (0, pda_1.findQuarryAddress)(this.rewarderKey, mint, this.program.programId);
            return quarryKey;
        });
    }
    /**
     * Creates a new quarry. Only the rewarder can call this.
     * @param param0
     * @returns
     */
    createQuarry({ token, authority = this.program.provider.wallet.publicKey, }) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const [quarryKey, bump] = yield (0, pda_1.findQuarryAddress)(this.rewarderKey, token.mintAccount, this.program.programId);
            const ix = this.program.instruction.createQuarry(bump, {
                accounts: {
                    quarry: quarryKey,
                    auth: {
                        authority,
                        rewarder: this.rewarderKey,
                    },
                    tokenMint: token.mintAccount,
                    payer: this.program.provider.wallet.publicKey,
                    clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                    systemProgram: web3_js_1.SystemProgram.programId,
                },
            });
            return {
                rewarder: this.rewarderKey,
                quarry: quarryKey,
                tx: this.sdk.newTx([ix]),
            };
        });
    }
    /**
     * Updates to daily rewards rate on the quarry, and update rewards on quarries assocated with each mint provided.
     * @param param0
     */
    setDailyRewards(newDailyRate, mints) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const authority = this.program.provider.wallet.publicKey;
            const tx = yield this.syncQuarryRewards(mints);
            tx.instructions.unshift(this.program.instruction.setDailyRewards(newDailyRate, {
                accounts: {
                    auth: {
                        rewarder: this.rewarderKey,
                        authority,
                    },
                    clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                },
            }));
            return tx;
        });
    }
    /**
     * Synchronizes quarry rewards.
     * @param mints
     * @returns
     */
    syncQuarryRewards(mints) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
            const instructions = [];
            yield Promise.all(mints.map((m) => (0, tslib_1.__awaiter)(this, void 0, void 0, function* () {
                const quarry = yield this.getQuarryKeyForMint(m);
                instructions.push(this.program.instruction.updateQuarryRewards({
                    accounts: {
                        rewarder: this.rewarderKey,
                        quarry,
                        clock: web3_js_1.SYSVAR_CLOCK_PUBKEY,
                    },
                }));
            })));
            return this.sdk.newTx(instructions);
        });
    }
}
exports.RewarderWrapper = RewarderWrapper;
//# sourceMappingURL=rewarder.js.map